// extracted by mini-css-extract-plugin
export var acitonButtons = "_g0-0";
export var additionalIcon = "_g0-f";
export var block = "_g0-1";
export var blockContent = "_g0-7";
export var blockDescription = "_g0-8";
export var blockIcon = "_g0-9";
export var blockTitle = "_g0-6";
export var border = "_g0-a";
export var center = "_g0-l";
export var edge = "_g0-b";
export var edgeLabel = "_g0-c";
export var edgePath = "_g0-d";
export var error = "_g0-e";
export var flowchart = "_g0-g";
export var flowchartContent = "_g0-h";
export var highlighted = "_g0-3";
export var hover = "_g0-4";
export var icon = "_g0-i";
export var left = "_g0-m";
export var navButton = "_g0-j";
export var navButtons = "_g0-k";
export var right = "_g0-n";
export var selected = "_g0-2";
export var small = "_g0-5";